import { create } from 'zustand';
export const usePaymentStore = create((set) => ({
    paymentType: [],
    setPaymentType: (paymentType) => set({ paymentType }),
    clearPaymentType: () => set({ paymentType: [] }),
}));
